import {
  addMinutes, format, formatDistanceStrict, setDefaultOptions,
} from 'date-fns';
import { ru } from 'date-fns/locale';

setDefaultOptions({ locale: ru });

const MOSCOW_OFFSET_MIN = 180;

export const toMoscowDate = (date) => {
  const d = new Date(date);
  return new Date(d.getTime() + (MOSCOW_OFFSET_MIN + d.getTimezoneOffset()) * 60000);
};

export const getTimeZoneDate = (date, useTimezone) => (
  useTimezone
    ? addMinutes(new Date(date), new Date(date).getTimezoneOffset())
    : new Date(date)
);

export const SERVER_DATE_MASK = 'yyyy-MM-dd HH:mm:ss';
export const HOURS_MINUTES_SECONDS_DATE_MASK = 'HH:mm:ss';

export const formatDate = ({ date, mask = 'dd-MM-yyyy', useTimezone }) => date
  && format(getTimeZoneDate(date, useTimezone), mask);

export const formatToServerDate = (date) => formatDate({ date, mask: SERVER_DATE_MASK });

const pad = (n) => String(n).padStart(2, '0');

export const formatToServerMoscow = (date) => {
  if (!date) return date;
  const d = new Date(date);
  const utcMs = Date.UTC(
    d.getFullYear(), d.getMonth(), d.getDate(),
    d.getHours(), d.getMinutes(), d.getSeconds(),
  ) - MOSCOW_OFFSET_MIN * 60000;
  const u = new Date(utcMs);
  return `${u.getUTCFullYear()}-${pad(u.getUTCMonth() + 1)}-${pad(u.getUTCDate())} `
    + `${pad(u.getUTCHours())}:${pad(u.getUTCMinutes())}:${pad(u.getUTCSeconds())}`;
};

export const getDayMonthYear = (date) => date
  && format(toMoscowDate(date), 'dd.MM.yyyy');

export const getDayMonthName = (date) => date
  && format(toMoscowDate(date), 'dd MMMM');

export const getHourMinute = (date) => date
  && format(toMoscowDate(date), 'HH:mm');

export const getDayMonthNameYear = (date) => date
  && format(toMoscowDate(date), 'dd MMMM yyyy');

export const getDayMonthNameYearTime = (date) => date
  && format(toMoscowDate(date), 'dd MMMM yyyy, HH:mm');

export const getDistanceDate = (fromDate, toDate) => {
  const from = new Date(fromDate);
  if (Number.isNaN(from.getTime())) return '';

  return formatDistanceStrict(from, toDate ? new Date(toDate) : new Date());
};
